import { Editor } from 'grapesjs';
import { QrCodeDataRenderer } from '@loyalty/editor-components';
import { EditorContext } from '../../../services/editor-service';
import { Toolbar, buildParticipantContextFromGrape } from '../../utils';

const CLASSNAME = 'qlfeditor-qrcode-data';

export function QrcodeDataGrapesComponent(editor: Editor) {
  const i18n = editor.I18n;

  editor.DomComponents.addType('qrcode-data', {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains(CLASSNAME);
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'content',
        attributes: {
          class: 'qlfeditor-qrcode-data--root',
        },
        traits: [],
        content: '',
        droppable: false,
        draggable: false,
        removable: false,
      },
      initToolbar: Toolbar,
      init() {
        this.listenTo(this, 'change:attributes', () => setTimeout(() => this.view?.onRender()));
      },
      toHTML(): string {
        return QrCodeDataRenderer(
          {
            state: (editor.Config?.context as EditorContext).widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
